import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateAdminInvoiceList = {
  adminInvoiceList: { data: null, loading: false, error: null },
};

export const adminInvoiceList = createAsyncThunk(
  "payment/adminInvoiceList",
  async (params = {}, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .get(`${process.env.REACT_APP_SERVER_API}/payments/apipay/admin/invoices/`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(res.response?.data || { error: "Ошибка загрузки инвойсов" })
      );
  }
);

export const reducerAdminInvoiceList = {
  [adminInvoiceList.pending]: (state) => {
    state.adminInvoiceList.loading = true;
    state.adminInvoiceList.error = null;
  },
  [adminInvoiceList.fulfilled]: (state, action) => {
    state.adminInvoiceList.loading = false;
    state.adminInvoiceList.data = action.payload;
    state.adminInvoiceList.error = null;
  },
  [adminInvoiceList.rejected]: (state, action) => {
    state.adminInvoiceList.loading = false;
    state.adminInvoiceList.data = null;
    state.adminInvoiceList.error = action.payload;
  },
};
